export const TRANSLATION_OVERVIEW_PATH = '/customer-communication/translation-overview';
export const TRANSLATION_CATALOG_PATH = '/customer-communication/translation-catalog';
